export default __webpack_public_path__ + "static/media/no-results.08c9d24d.svg";